"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconFilter = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconFilter = function IconFilter(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.918 20.513c.129-.033.195-.162.195-.292l-.001-6.433c0-.487.162-.975.454-1.364l6.369-8.902a.325.325 0 00-.26-.52L3.325 3a.325.325 0 00-.26.52l6.369 8.902c.292.39.454.877.454 1.365v7.764c0 .262.227.424.423.327z",
    fillRule: "evenodd"
  }));
};
exports.IconFilter = IconFilter;